import { History } from 'history';

export default function redirectTo(url: string, history: History, state?: { currentPage: number }, externalUrl?: boolean) {
  if (externalUrl) {
    window.location.replace(url);
  } else {
    history.push(url, state);
  }
}
